export async function googleRecaptcha(recaptcha: any) {
    /***********
     * Google Recaptcha validation
     **********/
    if (!recaptcha) {
        console.log("not available to execute recaptcha");
        return false;
    }

    const gRecaptchaToken = await recaptcha("inquirySubmit");

    const formData = {
        gRecaptchaToken,
    };

    try {
        const response = await fetch("/api/recaptchaSubmit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        });

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const responseData = await response.json();

        // if recaptcha success, then submit form
        if (responseData?.success === true) {
            // console.log(`Success with score: ${responseData?.score}`);
            const newToken = await recaptcha("inquirySubmit");
            return newToken;
        } else {
            // if recaptcha fail
            // console.log(`Failure with score: ${responseData?.score}`);
            return false;
        }
    } catch (error) {
        console.error("Error submitting form:", error);
    }
}
